import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import toast from "react-hot-toast"

export default {
  errorServidor(message?: { body?: string; duration?: number }) {
    toast.error(
      message?.body ||
        "Ha ocurrido un error en el servidor, inténtelo de nuevo más tarde",
      {
        duration: message?.duration ?? 4000,
        style: {
          borderRadius: "10px",
          background: "#FFF5F5",
          padding: "1em 0.3em 1em 1em",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
        },
      }
    )
  },
  warning(message?: { body?: string; duration?: number }) {
    toast(message?.body || "Ha habido un error de validación", {
      icon: "⚠️",
      duration: message?.duration ?? 3000,
      style: {
        borderRadius: "10px",
        background: "#FFF5E5",
        padding: "1em 0.3em 1em 1em",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
      },
    })
  },
  success(message?: { body?: string; duration?: number }) {
    toast.success(message?.body || "La operación se ha completado con éxito", {
      duration: message?.duration ?? 4000,
      style: {
        borderRadius: "10px",
        background: "#F0FFF0",
        padding: "1em 0.3em 1em 1em",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
      },
    })
  },
  info(message: $TSMigrationFixMe) {
    return toast(message?.body || "", {
      duration: message?.duration ?? 3000,
      icon: (
        <FontAwesomeIcon
          className='tw-text-text-hyperlinks tw-size-5'
          icon={message?.icon ?? ["fas", "info-circle"]}
          spin={message?.isIconSpin || false}
        />
      ),
      style: {
        borderRadius: "10px",
        background: "#F0F4FF",
        padding: "1em 0.3em 1em 1em",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
      },
    })
  },
  dismiss(toastId: string) {
    toast.dismiss(toastId)
  },
}
